module.exports = __webpack_public_path__ + "img/qr-prize.adb8658f.png";